export function toggleFavoriteOffer(toggle: HTMLElement) {
    fetch(`/favorite-offer/${toggle.dataset.favoriteOffer}`, { method: "PUT" })
        .then((response) => response.text())
        .then(state => toggle.classList.toggle('is-favorite', !!parseInt(state)))
}
